'use client'

import { Brain, Heart, Users } from 'lucide-react'
import TeamPhilosophyCard from '@/components/team/teamPhilosophyCard'

const TeamPhilosophySection: React.FC = () => (
  <section className="py-10 sm:py-12 md:py-16 bg-white">
    <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-8 text-center">
      <h2 className="text-[26px] sm:text-3xl font-bold text-gray-900 mb-6 sm:mb-8 leading-tight">
        Our Approach to Care
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-7 md:gap-8">
        <TeamPhilosophyCard
          icon={Brain}
          title="Evidence-Based"
          description="We use proven therapeutic techniques backed by research"
        />
        <TeamPhilosophyCard
          icon={Heart}
          title="Compassionate"
          description="Every patient is treated with dignity and respect"
        />
        <TeamPhilosophyCard
          icon={Users}
          title="Collaborative"
          description="We work together with you to achieve your goals"
        />
      </div>
    </div>
  </section>
)

export default TeamPhilosophySection
